import { getFacebookProperties } from "../../campaigns/facebook/thunk";
import { getFacebookBusinessesList, getFacebookCatalogList, refreshFacebookBusinessList, refreshFacebookCatalogList } from "./thunk";

export const facebook = {
  state: {
    fbCatalogPublishSettings: false,
    userFacebookId: null,
    isUserAuthChecked: false,
    businessList: [],
    fbBusinessId: null,
    catalogList: [],
    catalogId: null,
    isBusinessAuthenticated: false,
  },
  reducers: {
    setFbCatalogPublishSettings(state, action) {
      state.fbCatalogPublishSettings = action.payload;
    },
    setUserFacebookId(state, action) {
      state.userFacebookId = action.payload;
    },
    setIsUserAuthChecked(state, action) {
      state.isUserAuthChecked = action.payload;
    },
    setBusinessList(state, action) {
      state.businessList = action.payload
    },
    setFbBusinessId(state, action) {
      state.fbBusinessId = action.payload;
    },
    setCatalogList(state, action) {
      state.catalogList = action.payload;
    },
    setCatalogId(state, action) {
      state.catalogId = action.payload;
    },
    setIsBusinessAuthenticated(state, action) {
      state.isBusinessAuthenticated = action.payload;
    }
  },
  getExtraReducers(builder) {
    builder.addCase(getFacebookBusinessesList.fulfilled, (state, action) => {
      state.businessList = action.payload;
    });
    builder.addCase(refreshFacebookBusinessList.fulfilled, (state, action) => {
      state.businessList = action.payload;
    });
    builder.addCase(getFacebookCatalogList.fulfilled, (state, action) => {
      state.catalogList = action.payload;
    });
    builder.addCase(refreshFacebookCatalogList.fulfilled, (state, action) => {
      state.catalogList = action.payload;
    });
    builder.addCase(getFacebookProperties.fulfilled, (state, action) => {
      state.catalogId = action.payload?.catalogId;
      state.fbBusinessId = action.payload?.businessId;
      state.userFacebookId = action.payload?.userFbId;
    });
    return null;
  }
}